import { Divider, message } from 'antd';
import { isEmpty } from 'lodash';
import { useCallback } from 'react';
import { useShallow } from 'zustand/react/shallow';
import HeaderWithColumnSelectionExport from '~/components/organisms/Shared/HeaderWithColumnSelectionExport';
import { SaleStatementTypeEnum } from '~/domain/enum/salesStatement/saleStatementType.enum';
import { ISalesStatementSummaryExportColumn } from '~/domain/model/SalesStatement/SalesStatement';
import { salesStatementIntermediationSummaryExport } from '~/services/producer/SalesStatement/SalesStatementService';
import useSaleStatementByTypeStore from '~/zustand/salesStatement/useSalesStatementByTypeStore';
import { IExportColumn } from '../../Shared/GenericExportModal/GenericExportModal';
import SalesStatementIntermediationSummaryTable from '../SalesStatementIntermediationSummaryTable';

export const title = 'Resumo Intermediação';
export const subtitle = 'Acompanhe a média de preços e quantidades vendidas por produto';

export default function SalesStatementIntermediationSummary() {
  const { formInstance, isDisabledButton, getSummaryExportParams } = useSaleStatementByTypeStore(
    useShallow(state => {
      return {
        formInstance: state.intermediationFormFilterInstance,
        isDisabledButton: isEmpty(state.intermediationTable.data),
        getSummaryExportParams: state.getSummaryExportParams,
      };
    }),
  );

  const handleOpenModal = useCallback(async () => {
    try {
      await formInstance?.validateFields?.();
    } catch (errorInfo) {
      message.warning(
        'Erro ao exportar os Extratos de Vendas de Intermediação. Por favor, verifique o formulário e tente novamente mais tarde',
      );
      throw errorInfo;
    }
  }, [formInstance]);

  const handleGetExcelExport = async (selectedColumns: string[]) => {
    await formInstance?.validateFields?.();
    const fields = await formInstance?.getFieldsValue?.();
    if (!fields)
      return Promise.reject(
        new Error(
          'Erro ao exportar os Extratos de Vendas de Intermediação. Por favor, verifique o formulário e tente novamente mais tarde',
        ),
      );

    const columns = selectedColumns.reduce(
      (acc, column) => ({ ...acc, [column]: true }),
      {} as ISalesStatementSummaryExportColumn,
    );

    const params = getSummaryExportParams(SaleStatementTypeEnum.Intermediation, columns);
    return salesStatementIntermediationSummaryExport(params);
  };

  const exportColumns: IExportColumn[] = [
    { key: 'productLongDescription', label: 'Produto', checked: true },
    { key: 'ProductCode', label: 'Código do Produto', checked: true },
    { key: 'qualityDescription', label: 'QLD.', checked: true },
    { key: 'producerTotalQuantity', label: 'Quantidade Total (produtor)', checked: true },
    { key: 'producerLowestPrice', label: 'Menor (produtor)', checked: true },
    { key: 'producerAveragePrice', label: 'Média (produtor)', checked: true },
    { key: 'producerHighestPrice', label: 'Maior (produtor)', checked: true },
    { key: 'overallTotalQuantity', label: 'Quantidade Total (geral)', checked: true },
    { key: 'overallLowestPrice', label: 'Menor (geral)', checked: true },
    { key: 'overallAveragePrice', label: 'Média (geral)', checked: true },
    { key: 'overallHighestPrice', label: 'Maior (geral)', checked: true },
  ];

  return (
    <div id="summary-intermediation">
      <Divider />
      <HeaderWithColumnSelectionExport
        title={title}
        subtitle={subtitle}
        isDisabledButton={isDisabledButton}
        fileName="resumo-intermediação.xlsx"
        onClickOpenModal={handleOpenModal}
        getExcelExport={handleGetExcelExport}
        exportColumns={exportColumns}
      />
      <SalesStatementIntermediationSummaryTable />
    </div>
  );
}
